import classNames from 'classnames';
import _ from 'lodash';
import React from 'react';
import { Link } from 'react-router-dom';
import { useReferenceData } from '../../hooks/use_reference_data';
import { RoutePaths } from '../../routes';
import { ContentWrapper } from '../content_wrapper/content_wrapper';
import cssStyles from './techniques_list.less';

export const TechniquesList = () => {
  const { allTechniques } = useReferenceData();
  const techniquesAlpha = _.orderBy(allTechniques, (s) => s.display_name.toLowerCase());

  return (
    <ContentWrapper tag="section" className={cssStyles.wrapper}>
      <h1 className={classNames(cssStyles.h1, 'mb-4')}>Techniques</h1>
      <ul className={cssStyles.allStyles}>
        {techniquesAlpha.map((technique) => (
          <li key={technique.name}>
            <Link
              to={`${RoutePaths.TECHNIQUES}/${technique.url_path}`}
              className={cssStyles.allStylesLink}
            >
              {technique.display_name}
            </Link>
          </li>
        ))}
      </ul>
    </ContentWrapper>
  );
};
